import thomas from "../../assets/people/thomas.png";

export default function TeametBag() {
  return (
    <div className="flex mx-auto flex-col md:flex-row  mt-10 md:mt-40 pb-0 md:pb-32 mb-20 items-center container md:px-0 md:mx-auto">
      <div className="pr-0 md:flex-[0_0_50%] mx-auto md:pl-[15px] md:pr-20 mr-auto">
        <img
          src={thomas}
          alt="TeametBag"
          className="rounded-2xl shadow-md max-w-full"
        />
        <p className="pt-4 m-0 text-[1.5rem] italic ">
          <span className="font-bold">Thomas Vilhelmsen</span>, Medstifter af
          Doctio
        </p>
      </div>

      <div className="md:px-[15px] md:w-1/2 mx-auto mt-16 md:mt-0">
        <span className="tracking-[1px] mb-2 leading-[1.2]  text-dbase font-medium">
          LÆGER MED EN VISION
        </span>
        <h3 className="text-dxl md:text-[2.5rem] mb-8 font-bold text-doctio-green">
          Transformér måden at journalføre på
        </h3>
        <p className=" font-medium">
          Øget krav om dokumentation, flere patienter og færre hænder til at
          gøre arbejdet har skabt et behov for nye løsninger til at frigive tid
          for sundhedspersonale. Vores vision er enkel. At optimere
          journalføringen og understøtte patientbehandlingen.
        </p>
        <p className="font-medium">
          I kontrast til traditionelle journalsystemer og indbyggede
          frasesystemer er Doctio en personlig cloudbaseret frasedatabase.
          Doctio tilbyder en webapplikation, der virker på tværs af
          journalsystemer, som kan være med til at øge effektiviteten, mindsker
          tiden brugt på journalføring samt fungerer som et klinisk
          understøttende behandlingsværktøj.
        </p>
        <a
          href="https://doctio.dk/teamet"
          className="text-white mx-auto md:mx-0 mt-20 md:mt-12 transition-colors duration-300  ease-in-out font-bold w-56 block rounded-full hover:bg-white hover:text-doctio-green hover:shadow-md bg-doctio-green focus:ring-4 focus:outline-none px-4 py-2 text-center"
        >
          Teamet bag
        </a>
      </div>
    </div>
  );
}
